if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return; // geen form → niets doen

        // Zorg dat variant input niet disabled is (als aanwezig)
        const vid = this.variantIdInput;
        if (vid) vid.disabled = false;

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          null;

        this.submitButton = this.querySelector('[type="submit"]');
        // Tekstspan expliciet targeten; fallback op eerste span
        this.submitButtonText =
          this.submitButton?.querySelector('[data-add-to-cart-text]') ||
          this.submitButton?.querySelector('span') ||
          null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Submit handler
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (!this.cart) {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // fetchConfig fallback (indien global niet bestaat)
        const baseConfig =
          (typeof fetchConfig === 'function' && fetchConfig('javascript')) || {
            method: 'POST',
            headers: { Accept: 'application/javascript' },
            credentials: 'same-origin',
          };
        baseConfig.headers = baseConfig.headers || {};
        baseConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        // Geen Content-Type bij FormData
        if (baseConfig.headers['Content-Type']) delete baseConfig.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          const sections =
            typeof this.cart.getSectionsToRender === 'function'
              ? this.cart.getSectionsToRender().map((s) => s.id)
              : [];
          if (sections.length) formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);

          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        baseConfig.body = formData;

        const addUrl =
          (window.routes && window.routes.cart_add_url) || (window.routes && window.routes.cart_add || null) || '/cart/add';

        fetch(addUrl, baseConfig)
          .then((r) => r.json().catch(() => ({})))
          .then((response) => {
            // Foutpad vanuit Shopify
            if (response && response.status) {
              if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartError) {
                publish(window.PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              // Alleen console log, geen UI wijziging - product is pas uitverkocht na betaling
              console.warn('[product-form] Cart error:', response.description);
              this.error = true;
              return;
            }

            // Geen cart (oud gedrag: ga naar cart pagina)
            if (!this.cart) {
              const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
              window.location = cartUrl;
              return;
            }

            // PubSub update (als aanwezig)
            if (!this.error && typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
              publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;

            // Toon "Toegevoegd!" feedback op de knop
            this.showAddedFeedback();

            // Als quick-add modal → wachten tot sluit en daarna renderen
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (typeof this.cart.renderContents === 'function') {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              if (typeof quickAddModal.hide === 'function') quickAddModal.hide(true);
            } else if (typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('[product-form] add error:', e);
            this.handleErrorMessage('Er ging iets mis bij het toevoegen.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart?.classList?.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText && window.variantStrings?.addToCart) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]') || null;
      }

      showAddedFeedback() {
        if (!this.submitButton) return;

        // Toon notificatie rechtsonder in de card
        const notification = document.createElement('div');
        notification.className = 'quick-add-notification';
        notification.textContent = 'Toegevoegd!';
        notification.style.cssText = `
          position: absolute;
          bottom: 5.5rem;
          right: 1.6rem;
          background: #49A592;
          color: white;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          z-index: 100;
          animation: fadeInOut 2s ease forwards;
        `;

        // Voeg animatie toe als die nog niet bestaat
        if (!document.getElementById('quick-add-notification-style')) {
          const style = document.createElement('style');
          style.id = 'quick-add-notification-style';
          style.textContent = `
            @keyframes fadeInOut {
              0% { opacity: 0; transform: translateY(5px); }
              15% { opacity: 1; transform: translateY(0); }
              85% { opacity: 1; transform: translateY(0); }
              100% { opacity: 0; transform: translateY(-5px); }
            }
          `;
          document.head.appendChild(style);
        }

        // Plaats notificatie in card-wrapper (niet in quick-add, dat breekt positioning)
        const cardWrapper = this.submitButton.closest('.card-wrapper');
        if (cardWrapper) {
          cardWrapper.appendChild(notification);
        }

        // Verwijder notificatie na 2 seconden
        setTimeout(() => {
          notification.remove();
        }, 2000);
      }
    }
  );
}
